var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayerFullscreen = function SvgPlayerFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.75 4.5h3.75v3.75M14.25 9.75 19.5 4.5M8.25 19.5H4.5v-3.75M9.75 14.25 4.5 19.5M19.5 15.75v3.75h-3.75M14.25 14.25l5.25 5.25M4.5 8.25V4.5h3.75M9.75 9.75 4.5 4.5"
  })));
};
export default SvgPlayerFullscreen;